import { styled } from "../../styles";

export const PaginationOuter = styled("div", {
  display: "flex",
  justifyContent: "center",
  padding: "12px 0",
});

// Pill-shaped container that wraps the page buttons + arrows.
export const PaginationPill = styled("div", {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "4px 8px",
  borderRadius: "9999px",
  backgroundColor: "$white",
});

export const PageButton = styled("button", {
  width: "30px",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: "none",
  borderRadius: "9999px",
  fontSize: "13px",
  fontFamily: "$openSans",
  cursor: "pointer",
  boxSizing: "border-box",
  backgroundColor: "transparent",
  color: "$charcoal",
  transition: "background-color 120ms ease, color 120ms ease",

  "&:hover": {
    backgroundColor: "$primary-20",
  },

  "&:focus": {
    outline: "none",
  },
  "&:focus-visible": {
    outline: "1.5px solid $primary",
    outlineOffset: "1px",
  },

  variants: {
    active: {
      true: {
        backgroundColor: "$gray-50",
        color: "$charcoal",
        fontWeight: 600,
        cursor: "pointer",

        "&:hover": {
          backgroundColor: "$primary-20",
        },
      },
    },
    isDisabled: {
      true: {
        opacity: 0.35,
        cursor: "not-allowed",

        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  },
});

export const Ellipsis = styled("span", {
  width: "24px",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "13px",
  fontFamily: "$openSans",
  color: "$gray-80",
  userSelect: "none",
});
